import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';

import { Action } from './types-and-interfaces';
import { TranslationModule } from '../../i18n';

@Component({
  selector: 'crm-dropdown-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatButtonModule, MatMenuModule, TranslationModule],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.scss',
})
export class DropdownComponent {
  protected isExpanded = signal<boolean>(false);

  @Input() actions?: Action[];

  toggle() {
    this.isExpanded.set(!this.isExpanded());
  }

  open() {
    this.isExpanded.set(true);
  }
}
